import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "gold-ring",
  "use": "gold-ring-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"gold-ring\">\n<g id=\"gold-ring_Group 58\">\n<circle id=\"gold-ring_Ellipse 28\" cx=\"8\" cy=\"8\" r=\"8\" fill=\"#D6B244\" />\n<circle id=\"gold-ring_Ellipse 29\" cx=\"8\" cy=\"8\" r=\"2\" fill=\"white\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol